import { MyKnownError, ListItemsResponse, PreoffersService, CandidateWorkingInfo } from '@innowise-group/core';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PreofferItemResponse } from './preoffers.types';
import { candidatePreofferInfoDataThunkTransform } from '@innowise-group/utilities';
import { AxiosResponse } from 'axios';

export const searchAllPreoffersThunk = createAsyncThunk<
  ListItemsResponse<PreofferItemResponse>,
  Parameters<typeof PreoffersService.searchAllPreoffers>[0],
  { rejectValue: MyKnownError }
>('preoffers/search', async (data, { rejectWithValue }) => {
  try {
    const response = await PreoffersService.searchAllPreoffers(data);

    return {
      ...response.data,
      content: (response.data.content || []).map((item: PreofferItemResponse) => ({
        ...item,
        id: item.candidate.id,
      })),
    };
  } catch (err) {
    return rejectWithValue({
      errorMessage: err.message,
    } as MyKnownError);
  }
});

export const updateCandidatePreofferInfoThunk = createAsyncThunk<
  AxiosResponse,
  {
    id: number;
    data: CandidateWorkingInfo;
    successCallback?: () => void;
  },
  { rejectValue: MyKnownError }
>('candidates/update', async ({ id, data, successCallback }, { rejectWithValue }) => {
  try {
    const mappedPreofferInfoData = candidatePreofferInfoDataThunkTransform(data);

    await PreoffersService.updateCandidatePreofferInfo(id, {
      hrmEmail: data.hrmEmail,
      isOutsideHrm: data.isOutsideHrm,
      ...mappedPreofferInfoData,
    });

    successCallback?.();
  } catch (err) {
    return rejectWithValue({
      errorMessage: err.message,
    } as MyKnownError);
  }
});
